import { render, staticRenderFns } from "./LastUpdatedAt.vue?vue&type=template&id=786a2803&scoped=true"
import script from "./LastUpdatedAt.vue?vue&type=script&lang=ts"
export * from "./LastUpdatedAt.vue?vue&type=script&lang=ts"
import style0 from "./LastUpdatedAt.vue?vue&type=style&index=0&id=786a2803&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a2803",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
